// formulář objednávky
function orderForm() {
  $('#insurance_subject_order_type_0').click(function () {
    $('.bike-drivers').removeClass('is-hidden');
    $('.e-bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.price-label').text('Na kolik chcete kolo pojistit?');
    $('.form-name-text').attr('placeholder', 'např. HONZA KOLO');
    $('.form-price-text').attr('placeholder', 'např. 30 990');
  });

  $('#insurance_subject_order_type_1').click(function () {
    $('.e-bike-drivers').removeClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.price-label').text('Na kolik chcete elektrokolo pojistit?');
    $('.form-name-text').attr('placeholder', 'např. JANA ELEKTROKOLO');
    $('.form-price-text').attr('placeholder', 'např. 50 990');
  });

  $('#insurance_subject_order_type_2').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').removeClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.price-label').text('Na kolik chcete koloběžku pojistit?');
    $('.form-name-text').attr('placeholder', 'např. MATY KOLOBĚŽKA');
    $('.form-price-text').attr('placeholder', 'např. 15 490');
  });

  $('#insurance_subject_order_type_3').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').removeClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.price-label').text('Na kolik chcete e-koloběžku pojistit?');
    $('.form-name-text').attr('placeholder', 'např. PATRIK E-KOLOBĚŽKA');
    $('.form-price-text').attr('placeholder', 'např. 24 990');
  });

  $('#insurance_subject_order_type_4').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').removeClass('is-hidden');
    $('.price-label').text('Na kolik chcete cyklovozík pojistit?');
    $('.form-name-text').attr('placeholder', 'např. TOBÍK CYKLOVOZÍK');
    $('.form-price-text').attr('placeholder', 'např. 15 490');
  });

  $('.select2').select2();

  $(document).ready(function () {
    // if ($('.order-2').length) {
    //   // scroll na sekci coinsurance
    //   $('html, body').animate(
    //     {
    //       scrollTop: $('#subject-coinsurances').offset().top,
    //     },
    //     800,
    //     function () {}
    //   );
    // }

    // zajištění načtených hodnot a schování/zobrazení správných polí
    let chosenSubjectType = $(
      "input[name='insurance_subject_order[type]']:checked"
    ).val();
    chosenSubjectType = parseInt(chosenSubjectType);
    if (chosenSubjectType == 1) {
      $('.bike-drivers').removeClass('is-hidden');
      $('.e-bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.price-label').text('Na kolik chcete kolo pojistit?');
      $('.form-name-text').attr('placeholder', 'např. HONZA KOLO');
      $('.form-price-text').attr('placeholder', 'např. 30 990');
    }
    if (chosenSubjectType == 2) {
      $('.e-bike-drivers').removeClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.price-label').text('Na kolik chcete elektrokolo pojistit?');
      $('.form-name-text').attr('placeholder', 'např. JANA ELEKTROKOLO');
      $('.form-price-text').attr('placeholder', 'např. 50 990');
    }
    if (chosenSubjectType == 3) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').removeClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.price-label').text('Na kolik chcete koloběžku pojistit?');
      $('.form-name-text').attr('placeholder', 'např. MATY KOLOBĚŽKA');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
    }
    if (chosenSubjectType == 4) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').removeClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.price-label').text('Na kolik chcete e-koloběžku pojistit?');
      $('.form-name-text').attr('placeholder', 'např. PATRIK E-KOLOBĚŽKA');
      $('.form-price-text').attr('placeholder', 'např. 24 990');
    }
    if (chosenSubjectType == 5) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').removeClass('is-hidden');
      $('.price-label').text('Na kolik chcete cyklovozík pojistit?');
      $('.form-name-text').attr('placeholder', 'např. TOBÍK CYKLOVOZÍK');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
    }

    /*$("input[type='text']").change(function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });*/
    $('.select-selected').change(function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });
  });
}
